// fetchLogs.ts
import { getAuthHeaders } from "../../utils/token";
import { api } from "../Users/user";

const BASE_URL = api + '/api/logs'; // Modificar la URL a la necesitada

export interface APILog {
  _id: string;
  ipAddress: string;
  route: string;
  action: string;
  method: string;
  timestamp: string;
  userAgent: string;
  userId: string | null;
  userRole: string | null;
}

interface FetchLogsParams {
  search?: string;
  sortBy?: string;
  order?: 'asc' | 'desc';
  limit?: number;
  page?: number;
}

export async function fetchLogs({
  search = '',
  sortBy = 'createdAt', // Cambia el campo por defecto si lo deseas
  order = 'asc',
  limit = 25,
  page = 1,
}: FetchLogsParams): Promise<APILog[] | any> {
  try {
    const queryParams = new URLSearchParams({
      search,
      sortBy,
      order,
      limit: limit.toString(),
      page: page.toString(),
    }).toString();

    const response = await fetch(`${BASE_URL}?${queryParams}`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los logs');
    }
    const res = await response.json();
    return res// Devolvemos los logs en formato JSON
  } catch (error) {
    console.error('Error al realizar fetch de logs:', error);
    throw error; // Lanzamos el error para que pueda ser capturado por el componente
  }
}
